export const _setParticipantComment= (state, action) => {
    state.value = action.payload;
};